import { GroupLandingCTAType } from './group-landing-page-cta.types'
import { USER_TYPE } from '../../../hooks'
import { ModalType } from '../group-plan-modal/index.types'

export enum ActionType {
  ErrorModal,
  Link,
}

export type ModalAction = {
  actionType: ActionType.ErrorModal
  modalType: ModalType
}

export type LinkAction = {
  actionType: ActionType.Link
  url: string
}

export type Action = ModalAction | LinkAction

export type ButtonContent = {
  caption: string
  testId: string
  actions: Record<USER_TYPE, Action>
}

export const content: Record<GroupLandingCTAType, ButtonContent> = {
  [GroupLandingCTAType.EVERYONE_UNLIMITED]: {
    caption: 'Get Everyone Unlimited',
    testId: 'cta-everyone-unlimited',
    actions: {
      [USER_TYPE.NEW_USER]: {
        actionType: ActionType.Link,
        url: '/family/create-account',
      },
      [USER_TYPE.SOLO_USER]: {
        actionType: ActionType.Link,
        url: '/family/confirm-solo-plan-change',
      },
      [USER_TYPE.GROUP_V1_MEMBER]: {
        actionType: ActionType.ErrorModal,
        modalType: ModalType.ALREADY_IN_GROUP,
      },
      [USER_TYPE.GROUP_V1_OWNER]: {
        actionType: ActionType.ErrorModal,
        modalType: ModalType.ALREADY_IN_GROUP,
      },
      [USER_TYPE.GROUP_V2_MEMBER]: {
        actionType: ActionType.ErrorModal,
        modalType: ModalType.ALREADY_IN_GROUP,
      },
      [USER_TYPE.GROUP_V2_OWNER]: {
        actionType: ActionType.Link,
        url: '/family/add-member',
      },
      [USER_TYPE.GROUP_OWNER_V1_FULL_GROUP]: {
        actionType: ActionType.ErrorModal,
        modalType: ModalType.ALREADY_IN_GROUP,
      },
      [USER_TYPE.GROUP_OWNER_V1_INACTIVE]: {
        actionType: ActionType.ErrorModal,
        modalType: ModalType.ALREADY_IN_GROUP,
      },
      [USER_TYPE.GROUP_OWNER_V2_FULL_GROUP]: {
        actionType: ActionType.ErrorModal,
        modalType: ModalType.FULL_GROUP,
      },
      [USER_TYPE.GROUP_OWNER_V2_INACTIVE]: {
        actionType: ActionType.ErrorModal,
        modalType: ModalType.GROUP_OWNER_INACTIVE,
      },
    },
  },
  [GroupLandingCTAType.MIX_AND_MATCH]: {
    caption: 'Get Mix and Match',
    testId: 'cta-mix-and-match',
    actions: {
      [USER_TYPE.NEW_USER]: {
        actionType: ActionType.Link,
        url: '/all-plans',
      },
      [USER_TYPE.SOLO_USER]: {
        actionType: ActionType.Link,
        url: '/dashboard/groups/add-sim',
      },
      [USER_TYPE.GROUP_V1_MEMBER]: {
        actionType: ActionType.ErrorModal,
        modalType: ModalType.ALREADY_IN_GROUP,
      },
      [USER_TYPE.GROUP_V1_OWNER]: {
        actionType: ActionType.Link,
        url: '/dashboard/groups/add-sim',
      },
      [USER_TYPE.GROUP_V2_MEMBER]: {
        actionType: ActionType.ErrorModal,
        modalType: ModalType.ALREADY_IN_GROUP,
      },
      [USER_TYPE.GROUP_V2_OWNER]: {
        actionType: ActionType.ErrorModal,
        modalType: ModalType.ALREADY_IN_GROUP,
      },
      [USER_TYPE.GROUP_OWNER_V1_FULL_GROUP]: {
        actionType: ActionType.ErrorModal,
        modalType: ModalType.FULL_GROUP,
      },
      [USER_TYPE.GROUP_OWNER_V1_INACTIVE]: {
        actionType: ActionType.ErrorModal,
        modalType: ModalType.GROUP_OWNER_INACTIVE,
      },
      [USER_TYPE.GROUP_OWNER_V2_FULL_GROUP]: {
        actionType: ActionType.ErrorModal,
        modalType: ModalType.ALREADY_IN_GROUP,
      },
      [USER_TYPE.GROUP_OWNER_V2_INACTIVE]: {
        actionType: ActionType.ErrorModal,
        modalType: ModalType.ALREADY_IN_GROUP,
      },
    },
  },
}
